import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header.js";
import Footer from "../components/Footer.js";
import BoyGirlBG from "../assets/images/boy-girl-bow.png";
import { featuredTreatments } from "../utils/featuredTreatmentsData.js";

const HomePage = () => {
  return (
    <>
      <Header />

      {/* Hero Section */}
      <section
        className="hero hero-mobile min-h-[50vh] flex items-center pt-20 bg-cover sm:bg-contain bg-center bg-no-repeat bg-fixed relative overflow-hidden"
        style={{ backgroundImage: `url(${BoyGirlBG})` }}
      >
        {/* Enhanced Overlay with gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-black/30 via-blue-900/20 to-black/40"></div>

        {/* Content */}
        <div className="container  mx-auto px-6 py-16 bg-gradient-to-br from-gray-900/80 via-gray-800/70 to-black/60 text-center text-white relative z-10 -mt-20 shadow-2xl border border-white/10">
          <h1 className="text-2xl md:text-4xl text-center font-extrabold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-sky-400 via-sky-300 to-sky-500 tracking-wide drop-shadow-2xl animate-fade-in">
            Welcome to Barma Sorig
          </h1>
          <h1 className="text-5xl md:text-7xl font-bold mb-8 py-2 text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-amber-400 to-yellow-500 drop-shadow-lg animate-fade-in delay-300">
            SORIG SPA
          </h1>
          <h2 className="text-2xl md:text-4xl text-center font-extrabold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-sky-400 via-sky-300 to-sky-500 tracking-wide drop-shadow-2xl animate-fade-in">
            Traditional{" "}
            <span className="italic font-medium text-amber-300">KU NYE</span>{" "}
            Massage
          </h2>
          <p className="text-xl md:text-2xl mb-10 max-w-4xl mx-auto leading-relaxed text-gray-100 font-light animate-fade-in delay-500">
            Discover the transformative power of traditional{" "}
            <span className="italic font-medium text-amber-300">Ku-Nye</span>{" "}
            treatments, where ancient Himalayan wisdom meets modern wellness
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8 animate-fade-in delay-700">
            <Link
              to="/booking"
              className="group relative px-10 py-5 bg-gradient-to-r from-amber-800 via-amber-900 to-amber-800 text-white font-bold rounded-full hover:from-amber-700 hover:via-amber-800 hover:to-amber-700 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl text-xl flex items-center overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
              <span className="relative">Book Your Session</span>
              <i className="fas fa-arrow-right ml-3 transform group-hover:translate-x-1 transition-transform duration-300"></i>
            </Link>
            <Link
              to="/services"
              className="group px-10 py-5 border-2 border-white/80 text-white font-bold rounded-full bg-gray-500 hover:bg-white hover:text-amber-900 hover:border-white transition-all duration-300 text-xl backdrop-blur-sm hover:shadow-xl transform hover:scale-105"
            >
              <span className="group-hover:text-amber-900 transition-colors duration-300">
                Explore Our Services
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="relative py-20 bg-gradient-to-br from-white via-blue-50 to-sky-100 overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="flex flex-col lg:flex-row items-center gap-16">
            {/* Medicine Buddha Image */}
            <div className="lg:w-1/2 w-full mb-10 lg:mb-0 lg:pr-10 flex justify-center">
              <div className="group relative">
                {/* Glowing ring effect */}
                <div className="absolute -inset-6 bg-gradient-to-r from-sky-400 via-blue-500 to-sky-600 rounded-full opacity-20 blur-xl group-hover:opacity-40 transition-all duration-500 animate-pulse"></div>

                <div className="relative rounded-3xl shadow-2xl overflow-hidden border-4 border-sky-200 bg-white">
                  <img
                    src="https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/Medicine+Buddha.JPG"
                    alt="Medicine Buddha"
                    className="w-full h-auto rounded-3xl object-cover"
                  />
                  <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-sky-900/90 via-sky-800/60 to-transparent px-8 py-4 text-white text-xl font-bold flex items-center rounded-b-3xl backdrop-blur-sm">
                    <span className="mr-3">Medicine Buddha</span>
                    <span className="ml-auto text-sm bg-sky-500 px-3 py-1 rounded-full shadow-lg animate-pulse">
                      Sacred Image
                    </span>
                  </div>
                </div>

                {/* Floating particles */}
                <div className="absolute -top-2 -right-2 w-4 h-4 bg-sky-400 rounded-full animate-ping opacity-75"></div>
                <div className="absolute -bottom-2 -left-2 w-3 h-3 bg-amber-400 rounded-full animate-ping opacity-75 delay-300"></div>
              </div>
            </div>

            {/* Content */}
            <div className="lg:w-1/2 w-full flex flex-col items-center">
              <div className="relative mb-10">
                <h2 className="text-2xl md:text-5xl text-center font-extrabold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-sky-700 via-sky-600 to-sky-800 tracking-wide drop-shadow-2xl">
                  FOR THE FIRST TIME IN BHUTAN
                </h2>
                {/* Decorative underline */}
                <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-40 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent rounded-full animate-pulse"></div>
              </div>

              <div className="mb-10 w-full flex flex-col items-center justify-center">
                {/* Enhanced Mantra Card */}
                <div className="p-8 bg-white/70 backdrop-blur-sm rounded-3xl shadow-2xl border border-sky-100">
                  {/* Tibetan Mantra */}
                  <p
                    className="text-4xl text-transparent bg-clip-text bg-gradient-to-r from-sky-600 to-blue-700 md:text-5xl font-bold mb-6 tracking-wide text-center drop-shadow-lg"
                    style={{ fontFamily: "Jomolhari, serif" }}
                  >
                    ཏདྱ་ཐཱ།
                    ཨོ་བྷི་ཥ་ཛྱེ་བྷི་ཥ་ཛྱེ་མ་ཧཱ་བྷཻ་ཥ་ཛྱེ་རཱ་ཛ་ས་མུངྒ་ཏེ་སྭཱ་ཧཱ།།
                  </p>
                  {/* Transliteration */}
                  <p className="text-xl text-sky-700 md:text-2xl font-bold mb-4 text-center tracking-wide">
                    Tadyatha Om Bhekhnadze Maha Bhekhnadze Radza Samudgate Swaha
                  </p>
                  {/* English meaning */}
                  <p className="italic text-lg md:text-xl text-center text-sky-800 font-medium leading-relaxed">
                    "I Prostrate to Medicine Buddha, the great physician, king
                    of physician, radiating lapis lazuli light"
                  </p>
                </div>
              </div>

              {/* New Packages Text */}
              <p className="text-xl md:text-2xl text-center text-sky-900 mb-8 font-semibold leading-relaxed max-w-2xl">
                We are bringing you several new treatment packages of{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-amber-800 font-bold">
                  Sowa Rigpa Tradition
                </span>
              </p>

              <div className="flex flex-col sm:flex-row gap-6">
                <Link
                  to="/packagesPage"
                  className="group relative px-10 py-4 border-3 border-amber-600 text-amber-700 font-bold rounded-full hover:bg-gradient-to-r hover:from-amber-600 hover:to-amber-700 hover:text-white hover:border-amber-700 transition-all duration-300 text-xl shadow-lg hover:shadow-xl transform hover:scale-105 overflow-hidden"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-amber-200/30 to-transparent -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                  <span className="relative flex items-center gap-3">
                    Explore Our Packages
                    <i className="fas fa-arrow-right transform group-hover:translate-x-1 transition-transform duration-300"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Enhanced Divider */}
      <div className="section-divider h-3 bg-gradient-to-r from-gray-100 via-amber-200 to-amber-900 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-pulse"></div>
      </div>

      {/* Treatments Section */}
      <section className="relative py-20 bg-gradient-to-br from-amber-900 via-amber-800 to-red-900 text-white overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-6xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-amber-100 to-yellow-300 serif drop-shadow-2xl">
              Our Featured Daily Service
            </h2>
            <p className="text-xl md:text-2xl max-w-4xl mx-auto text-amber-100 font-light leading-relaxed">
              Each therapy is carefully selected and administered by our expert
              practitioners to address your unique needs.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {featuredTreatments.map((treatment, index) => (
              <div
                key={index}
                className="group treatment-card bg-gradient-to-br from-white via-gray-50 to-white text-gray-800 rounded-2xl p-8 shadow-2xl border border-amber-100"
              >
                <div className="relative mb-6">
                  <div className="absolute inset-0 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full blur-lg opacity-20 group-hover:opacity-40 transition-opacity duration-500"></div>
                  <div className="relative treatment-icon text-5xl text-transparent bg-clip-text bg-gradient-to-br from-amber-600 to-amber-800 flex justify-center">
                    <i className={treatment.icon}></i>
                  </div>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold mb-4 serif text-center text-transparent bg-clip-text bg-gradient-to-r from-gray-800 to-gray-700">
                  {treatment.title}
                </h3>
                <p className="mb-6 text-gray-700 leading-relaxed text-center font-medium">
                  {treatment.description}
                </p>
                <div className="text-center">
                  <Link
                    to={`/booking?service=${encodeURIComponent(
                      treatment.title
                    )}`}
                    className="group/link inline-flex items-center text-red-600 hover:text-red-700 font-bold text-lg transition-colors duration-300"
                  >
                    Book Now
                    <i className="fas fa-arrow-right ml-2 transform group-hover/link:translate-x-1 transition-transform duration-300"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      {/* Custom animations using Tailwind's arbitrary properties */}
      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }

        .delay-300 {
          animation-delay: 0.3s;
        }

        .delay-500 {
          animation-delay: 0.5s;
        }

        .delay-700 {
          animation-delay: 0.7s;
        }
      `}</style>
    </>
  );
};

export default HomePage;
